<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
  <div class="rounded-t border-b-2 mb-0 px-6 py-6">
    <div class="text-center flex justify-between">
      <h6 class="text-primary text-xl font-bold"> برنامه پزشک </h6>

    </div>
  </div>

  
  <div class="flex flex-wrap pt-6">
    <div class="w-full lg:w-2/12 px-4">
        <div class="relative w-full mb-3">
          <label class="block text-blueGray-600 text-sm font-bold mb-2"> مدت زمان ویزیت تصویری </label>
          <select disabled [(ngModel)]="drTimeCounter.videoCounter" class="p-3 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded w-full">
            <option value="null"> --- </option>
            <option value="10"> ۱۰ دقیقه </option>
            <option value="15"> ۱۵ دقیقه </option>
            <option value="20"> ۲۰ دقیقه </option>
            <option value="30"> ۳۰ دقیقه </option>
            <option value="60"> ۶۰ دقیقه </option>
          </select>
        </div>
    </div>
    <div class="w-full lg:w-2/12 px-4">
        <div class="relative w-full mb-3">
          <label class="block text-blueGray-600 text-sm font-bold mb-2"> مدت زمان ویزیت تلفنی</label>
          <select disabled [(ngModel)]="drTimeCounter.soundCounter" class="p-3 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded w-full">
            <option value="null"> --- </option>
            <option value="10"> ۱۰ دقیقه </option>
            <option value="15"> ۱۵ دقیقه </option>
            <option value="20"> ۲۰ دقیقه </option>
            <option value="30"> ۳۰ دقیقه </option>
            <option value="60"> ۶۰ دقیقه </option>
          </select>
        </div>
    </div>
    <!-- <div class="w-full lg:w-2/12 px-4">
        <div class="relative w-full mb-3">
          <label class="block text-blueGray-600 text-sm font-bold mb-2">  مدت زمان ویزیت متنی  </label>
          <select [(ngModel)]="drTimeCounter.videoCounter" disabled class="p-3 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded w-full">
            <option value="15"> ۱۵ دقیقه </option>
            <option value="20"> ۲۰ دقیقه </option>
            <option value="30"> ۳۰ دقیقه </option>
            <option value="60"> ۶۰ دقیقه </option>
          </select>
        </div>
    </div> -->
    <div class="w-full lg:w-2/12 px-4">
        <div class="relative w-full mb-3">
          <label class="block text-blueGray-600 text-sm font-bold mb-2">  مدت زمان ویزیت حضوری </label>
          <select disabled [(ngModel)]="drTimeCounter.bodyCounter" class="p-3 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded w-full">
            <option value="null"> --- </option>
            <option value="10"> ۱۰ دقیقه </option>
            <option value="15"> ۱۵ دقیقه </option>
            <option value="20"> ۲۰ دقیقه </option>
            <option value="30"> ۳۰ دقیقه </option>
            <option value="60"> ۶۰ دقیقه </option>
          </select>
        </div>
    </div>
  </div>

  <div class="flex-auto p-4">
      <div class="relative w-full overflow-x-auto rounded-md">
          <table class="w-full bg-transparent border-collapse">
            <thead class="bg-primary text-white">
              <tr>
                <th
                  class="px-6 align-middle border border-solid py-3 text-base border-l-0 border-r-0 font-semibold"  >
                      روزهای هفته
                </th>
                <!-- <th
                  class="px-6 align-middle border border-solid py-3 text-base border-l-0 border-r-0 font-semibold" >
                      زمان شروع
                </th>
                <th
                  class="px-6 align-middle border border-solid py-3 text-base border-l-0 border-r-0 font-semibold" >
                      زمان پایان
                </th> -->
                <th class="px-6 align-middle border border-solid py-3 text-base border-l-0 border-r-0 font-semibold " >
                  متنی
                </th>
                <th
                  class="px-6 align-middle border border-solid py-3 text-base border-l-0 border-r-0 font-semibold" >
                  تلفنی
                </th>
                <th
                  class="px-6 align-middle border border-solid py-3 text-base border-l-0 border-r-0 font-semibold" >
                 تصویری 
                </th>
                <th
                  class="px-6 align-middle border border-solid py-3 text-base border-l-0 border-r-0 font-semibold" >
                  حضوری
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let time of drCalendarList" class="border-b">
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs p-4">
                  {{time.day==0?'یکشنبه':time.day==1?'دوشنبه':time.day==2?'سه شنبه':time.day==3?'چهارشنبه':time.day==4?'پنجشنبه':time.day==5?'جمعه':time.day==6?'شنبه':null}}
                </td>
                  <ng-container *ngFor="let visit of time.visitTypes">
                
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-sm p-4">
                <input disabled id="" type="checkbox" value="" name="" [(ngModel)]="visit.isActive"
                  class="w-4 h-4 text-primary bg-gray-100 border-gray-300 rounded">
                  &nbsp; &nbsp;
                  <label class="text-xs" for="" class="m-1"> از </label> 
                   <select disabled name="" id="" [(ngModel)]="visit.start" class="p-1 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded w-16 text-xs">
                    <option *ngFor="let h of hourList" [value]="h.value"> {{h.title}} </option>
                   </select>
                  <label class="text-xs" for="" class="m-1">تا</label> 
                   <select disabled name="" id="" [(ngModel)]="visit.end" class="p-1 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded w-16 text-xs">
                    <option *ngFor="let h of hourList" [value]="h.value"> {{h.title}} </option>
                   </select>
                </td>
                </ng-container>
              </tr>
              
            </tbody>
          </table>
        </div>
  </div>

  <hr>

  <div class="flex flex-wrap p-4">
    <h4 class="text-base py-1">
      روز های تعطیل و استثنا پزشک:
    </h4>
    <div class="w-full flex mt-8">
        <span *ngFor="let exp of exceptionDays" class="bg-blue-100 text-blue-800 text-sm font-medium me-2 px-4 py-1 rounded border border-primary m-2 inline-flex">
         
          {{exp.exception | shamsiDate}}
        </span>
    </div>
  </div>
</div>